// API client del editor de Prompt del Agente — habla con el proxy de Orión
// (/orion/api/prompts/*), que resuelve el org_id SERVER-SIDE desde el JWT
// (nunca del navegador). Mismo patrón de auth (Bearer de localStorage) que
// governance / consolidation / memory-graph.

const ORION = '/orion/api';
const BASE = '/prompts';

function authHeaders(): Record<string, string> {
  const token = localStorage.getItem('auth_token');
  return { Authorization: `Bearer ${token ?? ''}` };
}

export interface PromptLayer {
  id: string;
  layer_type: string;
  name: string | null;
  description: string | null;
  content: string;
  version: number;
  is_locked: boolean;
  is_active: boolean;
  org_id: string | null;
  updated_at: string | null;
  created_at: string | null;
  updated_by_user_id: string | null;
  created_by_user_id: string | null;
}

export interface PromptVersion {
  id: string;
  version: number;
  is_active: boolean;
  name: string | null;
  description: string | null;
  content_preview: string;
  content_length: number;
  updated_at: string | null;
  created_at: string | null;
  updated_by_user_id: string | null;
  created_by_user_id: string | null;
}

async function req<T>(path: string, init?: RequestInit): Promise<T> {
  const res = await fetch(`${ORION}${BASE}${path}`, {
    ...init,
    headers: { 'Content-Type': 'application/json', ...authHeaders(), ...(init?.headers ?? {}) },
  });
  const body = await res.json().catch(() => ({}));
  if (!res.ok) {
    const raw = (body as { detail?: unknown; error?: unknown }).detail
      ?? (body as { error?: unknown }).error;
    const msg = typeof raw === 'string' ? raw : raw ? JSON.stringify(raw) : `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return body as T;
}

export const promptApi = {
  // org_id lo fija el proxy desde el JWT — jamás se manda desde el cliente.
  getBase: () => req<{ success: boolean; prompt: PromptLayer | null }>('/org-base'),
  // Guardar = versión NUEVA que se activa al instante (update_prompt_as_new_version).
  saveBase: (content: string, reason?: string) =>
    req<{ success: boolean; prompt: PromptLayer }>('/org-base', {
      method: 'PUT',
      body: JSON.stringify({ content, reason }),
    }),
  getHistory: (limit = 30) =>
    req<{ success: boolean; org_id: string; versions: PromptVersion[] }>(
      `/org-base/history?limit=${limit}`,
    ),
  // Rollback = "asignar la versión funcional": reactiva una versión anterior.
  rollback: (promptId: string) =>
    req<{ success: boolean; prompt: PromptLayer; message?: string }>('/org-base/rollback', {
      method: 'POST',
      body: JSON.stringify({ prompt_id: promptId }),
    }),
};
